// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mfa-modal {
  width: 100%;
  max-width: 400px;
  background: var(--modal-background, var(--surface, #fff));
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 16px;
  box-shadow: var(--modal-shadow, 0 24px 48px rgba(15, 23, 42, 0.2));
  padding: 0 !important;
  overflow: hidden;
}

.mfa-modal .modal-header,
.modal-header {
  padding: 1.15rem 1.35rem;
  background: var(--modal-background, var(--surface, #fff));
  color: var(--text-primary, #0f172a);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 1px solid var(--border, #e2e8f0);
  border-radius: 16px 16px 0 0;
}

.modal-body {
  padding: 1.5rem;
}

.modal-footer {
  padding: 1rem 1.5rem;
  border-top: 1px solid #e9ecef;
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
}

.mfa-description {
  color: #6c757d;
  margin-bottom: 1.25rem;
  font-size: 0.9rem;
  line-height: 1.5;
}

.mfa-input {
  font-size: 1.25rem !important;
  letter-spacing: 0.25em;
  text-align: center;
  font-family: monospace;
  padding: 0.75rem !important;
}

.verify-btn {
  min-width: 100px;
}

.loading-text {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top-color: white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
`, "",{"version":3,"sources":["webpack://./src/styles/mfa-modal.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,yDAAyD;EACzD,wCAAwC;EACxC,mBAAmB;EACnB,kEAAkE;EAClE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,wBAAwB;EACxB,yDAAyD;EACzD,mCAAmC;EACnC,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,+CAA+C;EAC/C,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf","sourcesContent":[".mfa-modal {\n  width: 100%;\n  max-width: 400px;\n  background: var(--modal-background, var(--surface, #fff));\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 16px;\n  box-shadow: var(--modal-shadow, 0 24px 48px rgba(15, 23, 42, 0.2));\n  padding: 0 !important;\n  overflow: hidden;\n}\n\n.mfa-modal .modal-header,\n.modal-header {\n  padding: 1.15rem 1.35rem;\n  background: var(--modal-background, var(--surface, #fff));\n  color: var(--text-primary, #0f172a);\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  border-bottom: 1px solid var(--border, #e2e8f0);\n  border-radius: 16px 16px 0 0;\n}\n\n.modal-body {\n  padding: 1.5rem;\n}\n\n.modal-footer {\n  padding: 1rem 1.5rem;\n  border-top: 1px solid #e9ecef;\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n}\n\n.mfa-description {\n  color: #6c757d;\n  margin-bottom: 1.25rem;\n  font-size: 0.9rem;\n  line-height: 1.5;\n}\n\n.mfa-input {\n  font-size: 1.25rem !important;\n  letter-spacing: 0.25em;\n  text-align: center;\n  font-family: monospace;\n  padding: 0.75rem !important;\n}\n\n.verify-btn {\n  min-width: 100px;\n}\n\n.loading-text {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid transparent;\n  border-top-color: white;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
